<template>
  <FooterView class="footer">
    <FooterBrand />
    <FooterInfo
      :contract="externalLinks.footer.contract"
      :phone="externalLinks.footer.phoneNumber"
      :email="externalLinks.footer.supportEmail"
    />
    <FooterPaymentSystems :payment-systems="paymentSystems" />
  </FooterView>
</template>

<script>
import { PaymentSystems } from '../config';
import { ExternalLinks } from '../config';
import FooterBrand from './footer-brand';
import FooterInfo from './footer-info';
import FooterPaymentSystems from './footer-payment-systems';
import FooterView from './footer-view';

export default {
  components: { FooterView, FooterBrand, FooterInfo, FooterPaymentSystems },
  computed: {
    paymentSystems() {
      return PaymentSystems;
    },
    externalLinks() {
      return ExternalLinks;
    }
  },
};
</script>

<style lang="scss" scoped>
.footer {
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  color: #09090B;
}
</style>
